import { render, staticRenderFns } from "./bind-personnel.vue?vue&type=template&id=2d4ed59a&"
import script from "./bind-personnel.vue?vue&type=script&lang=js&"
export * from "./bind-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports